import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import CompactFooterLeft from 'components/customer/compact_footer_left';
import CompositionManager from 'components/customer/composition_manager';
import ConversationAssignment from 'components/customer/conversation_history/conversation_assignment';
import ConversationTopics from 'components/customer/conversation_topics';
import WorkflowButtons from 'components/customer/workflow_buttons';

function CustomerFooter({ isCompactMode = false }) {
  if (isCompactMode) {
    return (
      <div className="customerV2-footer" data-aid="customerV2-footer">
        <CompactFooterLeft />
        <CompositionAreaWrapper>
          <CompositionManager />
        </CompositionAreaWrapper>
        <CompactWorkflowWrapper>
          <WorkflowButtons />
        </CompactWorkflowWrapper>
      </div>
    );
  }

  return (
    <div className="customerV2-footer" data-aid="customerV2-footer">
      <ConversationAssignment />
      <CompositionAreaWrapper>
        <CompositionManager />
      </CompositionAreaWrapper>
      <ConversationTopics />
      <WorkflowButtons />
    </div>
  );
}

CustomerFooter.propTypes = {
  isCompactMode: PropTypes.bool,
};

export default React.memo(CustomerFooter);

const CompositionAreaWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-grow: 1;
  height: 100%;
  min-width: 0;
`;

const CompactWorkflowWrapper = styled.div`
  flex-shrink: 0;

  /* Tighten the Buttons wrapper spacing */
  > div {
    margin-left: 4px;
    padding: 0 16px 0 4px;
  }

  .composerButtons-portal-active {
    width: auto;
  }

  .compositionForm-formButtons [data-aid='cancel-composition'] {
    margin-right: 8px;
  }
`;
